import { useDecision } from '@optimizely/react-sdk'
import { useSelector } from 'react-redux'

import { getIsAuthenticated } from 'selectors/auth'

export function useContextualSidesEnabled() {
  const isAuthenticated = useSelector(getIsAuthenticated)
  const [contextualSides] = useDecision('turnips_ofx_contextual_sides')

  return isAuthenticated && contextualSides.variationKey === 't1'
}
